import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';

@Component({
    name: 'm-roster-upload',
    components: {
        'm-roster-data': () => import('@/routers/m-views/m-setup/m-roster-setup/m-roster-data/m-roster-data.vue'),
    },
})

export default class RosterUpload extends Vue {

    // -------------------------------------------------------------------
    // Properties

    private isLoading: boolean = false;

    private customRosterData: any = [];

    private isRosterDataPullUp: boolean = false;

    private tenantId: string = '';

    private userId: string = '';

    private perPage: number = 10;

    private totalRowCounts: number = 0;

    private limit: number = 10;

    private offset: number = 0;

    private selectedCustomType: any = CUSTOM_ROSTER_SELECTION_TYPE[0].identifier;

    private fileUploadResponces: any = FILE_UPLOAD_RESPONCE;

    private currentPage: number = 1;

    private rosterData: any = [];


    public created() {
        this.tenantId = this.$access.getTenantId();
        this.userId = this.$access.getUserId();
        const paging = {
            offset: 0,
            limit: this.perPage,
        };
        this.getCustomRosterList(paging);
    }

    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions
    // ---------------------------------------------------------------------
    // Methods
    private getCustomRosterList(paging: any) {
        this.isLoading = true;
        const type = this.selectedCustomType === CUSTOM_ROSTER_SELECTION_TYPE[0].identifier ? 'roster' : 'hierarchy';
        rosterAPI.getCustomRosterList(this.tenantId, this.userId, paging , type).then((data: any) => {
            this.isLoading = false;
            data.list.map((content: any) => {
                content.created_at = moment(content.created_at).format('DD MMM YYYY');
            });
            this.customRosterData = data.list;
            this.totalRowCounts = data.totalCounts;
        });
    }
    private onSelectPage(pageNumber: number) {
        this.currentPage = pageNumber;
        const currentOffset = (pageNumber - 1) * this.perPage;
        const paging = {
            offset: currentOffset,
            limit: this.perPage,
        };
        this.getCustomRosterList(paging);
    }

    private viewRosterDetails(data: any) {
        this.rosterData = data;
        this.isRosterDataPullUp = true;
    }

    private onClose() {
        this.isRosterDataPullUp = false;
    }
    private onRefresh() {
        this.currentPage = 1;
        const paging = {
            offset: 0,
            limit: this.perPage,
        };
        this.getCustomRosterList(paging);
    }
}
